/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Title_LeadInputs */

const en_price_page_title_lead = /** @type {(inputs: Price_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free.`)
};

const pl_price_page_title_lead = /** @type {(inputs: Price_Page_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij za darmo.`)
};

/**
* | output |
* | --- |
* | "Start free." |
*
* @param {Price_Page_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_title_lead = /** @type {((inputs?: Price_Page_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_title_lead(inputs)
	return en_price_page_title_lead(inputs)
});